import {roles} from "@/Enums";
import type {AuthorizedActions} from "@/authorization";

const accountDataPolicies: AuthorizedActions = {
  read: [roles.Hauptbenutzer],
  edit: [roles.Hauptbenutzer],
  download: undefined
}

export {
  accountDataPolicies
}
